import React from 'react';
import {
	createStyles, Theme, WithStyles, withStyles,
} from '@material-ui/core/styles';
// @ts-ignore
import ReactTable from 'react-table';
import {injectIntl, WrappedComponentProps} from 'react-intl';
import 'react-table/react-table.css';

// @ts-ignore
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import ImportanceMeasureComparisonPlot from './ImportanceMeasureComparisonPlot';
import {QRLabelMapJSON} from "../../../Quantification/QuantificationResultJSON";
import ImportanceDataTableColumnsComparison from './ImportanceDataTableColumnsComparison';

const styles = (theme: Theme) => createStyles({
	darker: {
		background: theme.palette.type === 'dark' ? 'rgba(60,60,60,0.2)' : 'rgba(120,120,120,0.08)',
	},
	root: {
		height: '100%',
		margin: '0',
		overflow: 'auto',
		padding: '0',
		fontFamily: theme.typography.fontFamily,
		color: theme.palette.text.primary,
	},
	probContainer: {
		marginBottom: theme.spacing(2),
	},
	tableContainer: {
		height: '100%',
		marginTop: '0',
	},
	labelProb: {
		fontSize: '2rem',
		userSelect: 'all',
	},
	rootProb: {
		padding: '24px 0px',
	},
	cutsetChip: {
		margin: `0px ${theme.spacing(0.5)}px`,
		flexDirection: 'row',
	},
	cutsetRowItem: {
		flexDirection: 'row',
	},
	cutsetRow: {
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
	},
	rowItem: {
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
	},
	subcomponent: {
		padding: `${theme.spacing(2)}px ${theme.spacing(6)}px`,
		background: 'rgba(0, 0, 0, 0.03)',
	},
	successBG: {
		backgroundColor: '#81c784',
		'&:hover': {
			backgroundColor: '#81c784'
		}
	},
	failureBG: {
		backgroundColor: '#e57373',
		'&:hover': {
			backgroundColor: '#e57373'
		}
	},
	defaultBG: {
		backgroundColor: 'lightgray',
		'&:hover': {
			backgroundColor: 'lightgray'
		}
	},
	fullWidth: {
		width: '100%'
	}
});

interface Props extends WithStyles<typeof styles>, WrappedComponentProps {
	data: Array<string>;
	cols: Array<string>;
	noSlide: boolean;
	title: string;
	loading: boolean;
	loadingText: string;
	noDataText: string;
	treeType: string;
	sequenceName: string;
	importanceData: string;
	map: QRLabelMapJSON;
}

interface State {
	contentIdx: number;
}

class ImportanceEndStatesComparisonTable extends React.Component <Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = { contentIdx: 0 };
	}

	render() {
		const {
			data, cols, intl, classes, title, noDataText, noSlide, treeType, sequenceName, ...others
		} = this.props;
		const { contentIdx } = this.state;
		return (
			<ReactTable
				data={data}
				// @ts-ignore
				columns={cols}
				defaultPageSize={10}
				style={{ height: '100%' }}
				className="-striped -highlight"
				SubComponent={(row: any) => {
					const data = row.original.measures.map((measure) => ({...measure, endstate: row.original.name}))
					return (
						<React.Fragment>
							{/*
              // @ts-ignore */}
							<Tabs
								value={contentIdx}
								indicatorColor="primary"
								textColor="secondary"
								centered
								fullWidth
							>
								<Tab label="Table" onClick={e => this.setState({ contentIdx: 0 })} />
								<Tab label="Plots" onClick={e => this.setState({ contentIdx: 1 })} />
							</Tabs>
							<div className={classes.darker}>
								{contentIdx === 0
								&& (

									// @ts-ignore
									<ReactTable
										data={data}
										// @ts-ignore
										noDataText={intl.formatMessage({ id: 'FaultTreeResultView.table.no_result' }, undefined, undefined, undefined, undefined)}
										columns={ImportanceDataTableColumnsComparison(this.props)}
										defaultPageSize={10}
										style={{ height: '100%' }}
										className="-striped -highlight"
									/>
								)
								}
								{contentIdx === 1
								&& (
									<ImportanceMeasureComparisonPlot
										data={data}
										map={this.props.map}
									/>
								)
								}
							</div>
						</React.Fragment>
					);
				}}
			/>
		);
	}
}

// @ts-ignore
export default withStyles(styles)(injectIntl(ImportanceEndStatesComparisonTable));
